import { USER_ID, GET_USERS_ALL, AUTH_ERROR, USER_DETAIL, LOGOUT } from '../Action-types';
const persistedState = JSON.parse(localStorage.getItem('persist:root') || '{}');
const auth = persistedState.auth ? JSON.parse(persistedState.auth) : {};

const initialState = {
  user: auth.user || null,
  userdetail: {},
  usersall: auth.usersall || [],
  token: auth.token || null,
  error: auth.error || null,
  isAuthenticated: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_AVATAR':
      return {
        ...state,
        usersall: action.avatar,
      };
    case LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
      };
    case 'UPDATE_VIP_STATUS':
      return {
        ...state,
        usersall: action.payload,
      };
    case 'UPDATE_PREMIUN_STATUS':
      return {
        ...state,
        usersall: action.payload,
      };
    case USER_DETAIL:
      return {
        ...state,
        userdetail: action.payload,
      };
    case GET_USERS_ALL:
      return {
        ...state,
        usersall: action.payload,
      };
    case USER_ID:
      return {
        ...state,
        user: action.payload.user,
        isAuthenticated: true,
        error: null,
      };

    case 'AUTH_SUCCESS':
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: true,
        error: null,
      };
    case AUTH_ERROR:
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
